import LocalSettingsProto from "../../core/gd/settings/local-settings/local-settings-v4";
import {ViewType} from "../../core/gd/const/views/view-type";
import {myWorkViewDictionary, MyWorkViewName, myWorkViewOptionDictionary} from "./my-work/common/@const";

// This may not be in use now ?!   But i added "currentView"
export default class MyWorkLocalSettings extends LocalSettingsProto {

    // New. Previously saved in "gd.user.settings.views.myWork.currentView"
    public currentViewId        : ID
    public currentViewType      : ViewType
    public isSubmenuCompact     : boolean

    constructor() {
        super("my-work-global")   // ! yes each company has their own settings

        const lsValues          = this._readFromLocalStorage();

        const defaultViewId: MyWorkViewName = gd.user.settings.views.myWork.get(gd.companyId).currentView ?
                                              gd.user.settings.views.myWork.get(gd.companyId).currentView :
                                              myWorkViewDictionary[ViewType.MY_WORK_VIEW_BOARD]

        const viewType: ViewType = myWorkViewOptionDictionary[defaultViewId]!.value

        this.currentViewId          = _.get(lsValues, 'currentViewId', defaultViewId)
        this.currentViewType        = _.get(lsValues, 'currentViewType', viewType)

        this.isSubmenuCompact        = _.get(lsValues, 'isSubmenuCompact', false)
    }

    toggleIsSubmenuCompact() {
        this.isSubmenuCompact = !this.isSubmenuCompact
        this.save()
    }

    toObject() {
        return {
            currentViewId       : this.currentViewId,
            currentViewType     : this.currentViewType,
            isSubmenuCompact    : this.isSubmenuCompact
        };
    }
}
